function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "No-Results-(IDN-checked)",
  transform: "translate(-752.000000, -479.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(752.000000, 475.000000)"
}, React.createElement("g", {
  id: "Faded-Check",
  transform: "translate(0.000000, 4.000000)"
}, React.createElement("rect", {
  id: "Rectangle-Copy-12",
  fill: "#B0C4D9",
  x: 0,
  y: 0,
  width: 18,
  height: 18
}), React.createElement("polygon", {
  id: "Path-10-Copy-2",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "13.251921 4.31295611 14.7051528 5.68704389 7.4378827 13.3728907 3.27115655 8.93740349 4.72884345 7.56804273 7.442 10.456"
})))));

var SvgCheckboxCheckedGrey = function SvgCheckboxCheckedGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "checkbox-checked-grey",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckboxCheckedGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkbox_checked_grey.b02985cf.svg";
export { ForwardRef as ReactComponent };